import { render } from "./CardRole.vue?vue&type=template&id=6345856f"
import script from "./CardRole.vue?vue&type=script&lang=js"
export * from "./CardRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__